import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
    0%, 100% { opacity: 0.6; transform: scale(0.95); }
    50% { opacity: 1; transform: scale(1.05); }
`;

const Overlay = styled.div`
    width: 100%;
    height: 100%;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: transparent;
    gap: 20px;
    animation: fadeIn 0.3s ease;

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
`;

const SpinnerContainer = styled.div`
    position: relative;
    width: 60px;
    height: 60px;
`;

const SpinnerRing = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 3px solid transparent;
    border-top-color: #6366f1;
    border-right-color: #a855f7;
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
    filter: drop-shadow(0 0 10px rgba(99, 102, 241, 0.5));
`;

const LoadingText = styled.div`
    font-family: 'Chakra Petch', sans-serif;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 2px;
    color: rgba(255, 255, 255, 0.7);
    text-transform: uppercase;
    animation: ${pulse} 1.5s ease-in-out infinite;
`;

const LoadingOverlay = ({ text = "LOADING MODULE..." }) => {
    return (
        <Overlay>
            <SpinnerContainer>
                <SpinnerRing />
            </SpinnerContainer>
            <LoadingText>{text}</LoadingText>
        </Overlay>
    );
};

export default LoadingOverlay;
